import { Col, Input, Label } from "reactstrap";
import { FilledRadios, ProductRadio } from "../../../../Constant";
import { FILL_RADIO_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";

export const FilledRadio = () => {
  return (
    <Col xl="4" sm="6">
      <div className="card-wrapper border rounded-3 fill-radios h-100 checkbox-checked">
        <H6 className="sub-title">{FilledRadios}</H6>
        <div className="form-check radio radio-primary">
          <Input id="radio111" type="radio" name="radio3" defaultChecked />
          <Label className="form-check-label" htmlFor="radio111" check>
            {ProductRadio}
          </Label>
        </div>
        {FILL_RADIO_LIST.map(({ id, text, color }, index) => (
          <div className={`form-check radio radio-${color}`} key={index}>
            <Input id={`radios-${id}`} type="radio" name="radio3" />
            <Label className="form-check-label" htmlFor={`radios-${id}`} check>
              {text}
            </Label>
          </div>
        ))}
      </div>
    </Col>
  );
};
